import { render } from "./SerialEnd.vue?vue&type=template&id=60272eff"
import script from "./SerialEnd.vue?vue&type=script&lang=js"
export * from "./SerialEnd.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__